import React from 'react';

import './PromoSection.css';
import VideoPlayer from '../videoComponents/VideoPlayer';


const PromoSection = (props) => {
  const { user, videoControl, mainImage, mainMobileImage, backgroundColor, homePage, checkoutURL } = props;

  const shouldLoopVideo = !user?.authenticated;

  return (
    <a href={checkoutURL}>
      <div className="container-fluid promo-wrapper" style={{ backgroundColor }}>
        <div className="container campaign-video-player">
          <div
            className="vivid-promo"
            style={{ backgroundImage: `url(${mainImage})` }}
          >
            <div
              className="vivid-promo-mobile"
              style={{ backgroundImage: `url(${mainMobileImage})` }}
            />
            <div className="vid-col" onClick={videoControl}>
              <div id="video">
                <VideoPlayer
                  autoPlayVideo={true}
                  homePage={homePage}
                  isPromoActive={props.isCampaignActive}
                  loopVideo={shouldLoopVideo}
                  mutedVideo={true}
                  user={user}
                />
                <a
                  className="btn cta-btn"
                  href={checkoutURL}
                >
                  Click here to Join today! »
                </a>
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    </a>
  );
};

export default PromoSection;
